// @flow
import type { TextProps } from './Text';
import type { Theme } from '../themes/types';
import Text from './Text';
import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'react-fela';

const Paragraph = (props: TextProps) => {
  const { theme } = props;
  const {
    marginBottom = theme.paragraph.marginBottom,
    maxWidth = theme.block.maxWidth,
    ...restProps
  } = props;
  return <Text marginBottom={marginBottom} maxWidth={maxWidth} {...restProps} />;
};

Paragraph.contextTypes = {
  theme: PropTypes.object,
};

export default withTheme(Paragraph, 'theme');
